export const EXPORT_POLLING_INTERVAL = 1000; // 1 second
